const HALLOWEEN_DEBUG_MODE = false;

export function isHalloweenMode()
{
    return HALLOWEEN_DEBUG_MODE || new Date().getMonth() === 9;
}
